import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  useSettings,
  FontSize,
} from '@/museum-app/context/settings-context';
import {
  ToggleGroup,
  ToggleGroupItem,
} from '@/components/ui/toggle-group'; // Assuming shadcn/ui toggle-group is available
import { Label } from '@/components/ui/label'; // Assuming shadcn/ui label is available

interface FontSizeOption {
  value: FontSize;
  labelKey: string; // Translation key
  defaultLabel: string; // Default label text
}

const fontSizeOptions: FontSizeOption[] = [
  { value: 'small', labelKey: 'settings.fontSize.small', defaultLabel: 'Small' },
  {
    value: 'medium',
    labelKey: 'settings.fontSize.medium',
    defaultLabel: 'Medium',
  },
  { value: 'large', labelKey: 'settings.fontSize.large', defaultLabel: 'Large' },
  {
    value: 'extra-large',
    labelKey: 'settings.fontSize.extraLarge',
    defaultLabel: 'Extra Large',
  },
];

const FontSizeSelector: React.FC = () => {
  const { fontSize, setFontSize } = useSettings();
  const { t } = useTranslation();

  const handleValueChange = (value: string) => {
    if (value) {
      // ToggleGroup returns the value when selected, empty string when deselected
      setFontSize(value as FontSize);
    }
  };

  return (
    <ToggleGroup
      type="single"
      value={fontSize}
      onValueChange={handleValueChange}
      aria-label={t('settings.fontSize.ariaLabel', 'Select font size')}
      className="flex flex-wrap gap-2"
    >
      {fontSizeOptions.map((option) => (
        <ToggleGroupItem
          key={option.value}
          value={option.value}
          aria-label={t(option.labelKey, option.defaultLabel)}
          className="px-4 py-2" // Add some padding for better touch targets
        >
          {t(option.labelKey, option.defaultLabel)}
        </ToggleGroupItem>
      ))}
    </ToggleGroup>
  );
};

export default FontSizeSelector;
